import { useEffect, useRef } from "react";

export function usePrevious<T extends object>(value: T): T | object {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);

  if (ref.current === undefined) {
    return {};
  }
  return ref.current;
}
